<div *ngIf="item" style="padding-right: 24px;">
    <div class="d-flex flex-column" style="gap:16px">

        <div class="d-flex flex-column">
            <div *ngFor="let ds of family; let index = index">
                <div class="d-flex align-items-center" style="height: 60px; gap:4px;">
                    <app-help-label toolTipMsg="Afegeix un Select dependent del anterior">
                        <div style="white-space: nowrap;">Nivell {{index+1}} </div>
                    </app-help-label>

                    <div class="d-flex align-items-center border-item" [class.border-item-primary]="ds==item">
                        <div class="div-label">{{ds.fieldLabel}}</div>
                        <div style="flex:1 0 0;"></div>
                        <mat-icon class="material-icons-outlined">arrow_drop_down_circle</mat-icon>
                    </div>
                    <div style="flex:1 0 0;"></div>
                    <div style="min-width: 40px;">
                        <button *ngIf="index == family.length-1 && family.length>1" mat-icon-button
                            (click)="removeParent(ds)">
                            <mat-icon class="material-icons-outlined">remove_circle_outline</mat-icon>
                        </button>
                    </div>

                </div>
            </div>
            <div class="d-flex flex-column" style="padding-top: 16px; gap:4px">

                <app-help-label   toolTipMsg="Afegeix un Select dependent del anterior">
                    Afegix dependéncia
                </app-help-label>
                <mat-form-field style="width: 100%;">
                    <mat-select #me (valueChange)="changeValue($event);me.value = null;">
                        <mat-option>

                        </mat-option>
                        <mat-option *ngFor="let ds of findSingleDataSourceItemMetadata()" [value]="ds">
                            {{ds.fieldLabel}}
                        </mat-option>

                    </mat-select>
                </mat-form-field>


            </div>

        </div>
        <mat-divider></mat-divider>
        <div class="d-flex flex-column" style="height: 100%; width: 100%; gap: 8px;">
            <app-help-label  toolTipMsg="Opcions per els selects dependents en format CSV. Columnes separades per ';'">
                Opcions per camps
            </app-help-label>

            <form [formGroup]="fieldForm">

                <mat-form-field style="width: 100%; height: 100%;">
                    <textarea matInput formControlName="csv" rows="10" style="height: 100%; width: 100%;"></textarea>
                </mat-form-field>
            </form>
            <div class="d-flex justify-content-start ">
                <button (click)="importCsv()" mat-stroked-button>Importa CSV</button>
            </div>

            <div>Copia l'exemple al portapapers:</div>
            <div class="d-flex justify-content-start ">
                <button mat-stroked-button [cdkCopyToClipboard]="createExample()">
                    <div class="d-flex align-items-center " style="gap:16px;">
                        <span class="material-icons-outlined">
                            content_copy
                        </span>
                        <span>Copia al portapapers</span>
                    </div>
                </button>
            </div>
            <pre>{{createExample()}}</pre>

        </div>

    </div>

</div>